import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  width: 100%;
  align-self: center;
`;
